import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useDialogData } from "../../dialogs/context/DialogProvider";
import { useGamesData } from "../../games/context/GamesProvider";
import { useScoreData } from "../../score/context/ScoreProvider";

export const UIToast = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [infos, setInfos] = useState("");
  const { isOpen } = useGamesData();
  const { currentDialog } = useDialogData();
  const { chapters } = useScoreData();

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setInfos(t(`ui.info.advice.main`));
        break;
      default:
        if (
          chapters.find(
            (chapter) => chapter.id === location.pathname.replace("/", "")
          )?.isDone
        )
          setInfos(t(`ui.info.advice.chapterComplete`));
        else setInfos(t(`ui.info.advice.poi`));
    }
  }, [location.pathname, t, isOpen, chapters]);

  return (
    <Snackbar
      open={infos !== "" && !isOpen && !currentDialog}
      sx={{ maxWidth: "25%" }}
    >
      <MuiAlert severity="warning" variant="standard">
        {parse(infos)}
      </MuiAlert>
    </Snackbar>
  );
};
